.container {
    padding-left: var(--page-padding);
    padding-right: var(--page-padding);
}
